import * as React from 'react'
import * as styles from './TimeInfo.module.scss'
import * as cn from 'classnames'

interface TimeInfoProps {
  label?: string
}

const TimeInfo = ({ label }: TimeInfoProps) => {
  if (!label) {
    return null
  }
  return (
    <div className={cn(styles.TimeInfo, 'tst-live-status')}>
      {label}
    </div>
  )
}

export default TimeInfo
